/* eslint-disable import-x/no-namespace */
import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';
import { format } from 'date-fns';
import i18next from 'i18next';
import { omit } from 'lodash';

import * as fastFilters from './fast-filters';
import { useListListPageFilters } from '../useListListPageFilters';

function getDateRangeLabel({
  from,
  to,
}: {
  from?: Date;
  to?: Date;
}): string {
  if (from && to) {
    return `${i18next.t('from_label')} ${format(from, 'dd.MM.yyyy')} ${i18next.t('to_label')} ${format(to, 'dd.MM.yyyy')}`;
  }
  if (from) {
    return `${i18next.t('from_label')} ${format(from, 'dd.MM.yyyy')}`;
  }
  if (to) {
    return `${i18next.t('to_label')} ${format(to, 'dd.MM.yyyy')}`;
  }
  return '';
}

function ListListPageFastFilters(): JSX.Element | null {
  const { filters, updateFilters } = useListListPageFilters();

  const hasFilters = Object
    .values(omit(filters, 'page', 'page_size'))
    .some((value) => value !== null && value !== undefined);

  if (!hasFilters) return null;

  return (
    <FastFilterGroup>
      {!!filters.user_data && (
        <fastFilters.NameFilterWithBottomPopover
          data-testid="user_data"
          key="user_data"
          onClear={() => updateFilters({ user_data: undefined })}
          value={filters.user_data}
        />
      )}
      {!!(filters.create_time__gte ?? filters.create_time__lt) && (
        <fastFilters.CreationDateFilterWithBottomPopover
          data-testid="create_time"
          key="create_time"
          onClear={() => updateFilters({ create_time__gte: undefined, create_time__lt: undefined })}
          value={getDateRangeLabel({
            from: filters.create_time__gte,
            to: filters.create_time__lt,
          })}
        />
      )}
      {!!(filters.last_update_time__gte ?? filters.last_update_time__lt) && (
        <fastFilters.UpdateDateFilterWithBottomPopover
          data-testid="last_update_time"
          key="last_update_time"
          onClear={() => updateFilters({ last_update_time__gte: undefined, last_update_time__lt: undefined })}
          value={getDateRangeLabel({
            from: filters.last_update_time__gte,
            to: filters.last_update_time__lt,
          })}
        />
      )}
    </FastFilterGroup>
  );
}

export { ListListPageFastFilters };
